import { render, staticRenderFns } from "./ColorSelect.vue?vue&type=template&id=a637bb5c&scoped=true&"
import script from "./ColorSelect.vue?vue&type=script&lang=js&"
export * from "./ColorSelect.vue?vue&type=script&lang=js&"
import style0 from "./ColorSelect.vue?vue&type=style&index=0&id=a637bb5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a637bb5c",
  null
  
)

export default component.exports